import axios, { Method } from 'axios';
import { decodeTokenValidate, getClientId, removeToken } from 'utils/methods';
import { decryptResponse } from 'utils/decrypt-response';
import { getStringFromLocalStorage } from 'utils/localStorage';
import * as dxc from './dxc.api';

import { Client } from 'types/enums';
import { API_REST_URL_COPILOT_APRENDIZAJE } from '../variables';

export const axiosPrivate = axios.create();

axiosPrivate.interceptors.request.use(async config => {
  const token = await decodeTokenValidate();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    const userData = getStringFromLocalStorage('user');
    const clientId = userData ? JSON.parse(userData)?.clientId : undefined;
    if (clientId) config.headers['lcd'] = clientId;
  }
  return config;
});

axiosPrivate.interceptors.response.use(
  response => {
    if (response.data?.encrypted === true && response.data?.payload) {
      response.data = decryptResponse(response.data.payload);
    }
    return response;
  },
  async error => {
    if (error?.response?.status === 401) {
      removeToken(true);
    }
    return Promise.reject(error);
  },
);

export const apiClient = async (
  url: string,
  method: Method,
  path: string,
  data?: any,
  headers?: any,
  params?: any,
  options?: any,
) => {
  return axiosPrivate({
    method,
    url: `${url}${path}`,
    data,
    headers,
    params,
    ...options,
  })
    .then(({ data }) => data)
    .catch(error => {
      throw error;
    });
};

export const apiClientPublic = async (
  url: string,
  method: Method,
  path: string,
  data?: any,
  params?: any,
) => {
  return axios({
    method,
    url: `${url}${path}`,
    data,
    params,
  })
    .then(({ data }) => data)
    .catch(error => { });
};

export const apiClientPublicV2 = async (
  url: string,
  method: Method,
  path: string,
  data?: any,
  params?: any,
) => {
  return axios({
    method,
    url: `${url}${path}`,
    data,
    params,
  })
    .then(({ data }) => data)
};

export const axiosDXC = axios.create();

axiosDXC.interceptors.request.use(async config => {
  const token = await decodeTokenValidate();
  const subdomain = getClientId(Client.TEAM);
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['client'] = subdomain;
  }
  return config;
});

export const apiClientDXC = async (
  url: string,
  method: Method,
  path: string,
  data?: any,
  headers?: any,
  params?: any,
  options?: any,
) => {
  return axiosDXC({
    method,
    url: `${url}${path}`,
    data,
    headers,
    params,
    ...options,
  })
    .then(({ data }) => data)
    .catch(error => {
      throw error;
    });
};

export { dxc };

export const axiosCopilot = axios.create();

axiosCopilot.interceptors.request.use(async config => {
  config.baseURL = API_REST_URL_COPILOT_APRENDIZAJE;
  const token = await decodeTokenValidate();
  const subdomain = getClientId(Client.TEAM);
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['client'] = subdomain;
    const userData = getStringFromLocalStorage('user');
    const clientId = userData ? JSON.parse(userData)?.clientId : undefined;
    if (clientId) config.headers['lcd'] = clientId;
  }
  return config;
});

export const apiClientCopilot = async (
  path: string,
  method: Method,
  data?: any,
  params?: any,
) => {
  return axiosCopilot({
    method,
    url: path,
    data,
    params,
  })
    .then(({ data }) => data)
    .catch(error => {
      throw error;
    });
};

export const axioswebhook = axios.create();
axioswebhook.interceptors.request.use(async config => {
  const token = await decodeTokenValidate();
  if (token) {
    config.headers['x-api-key'] = token;
  }
  return config;
});
